import { type AppScreen } from "@/constants/Screens"
import {
  createComponentClickedEvent,
  createScreenViewedEvent,
  track,
} from "./base"
import { type PreQualQuestionConfig } from "@/constants/preQual"

export const preQualStepViewed = (currentScreen: AppScreen) => {
  track(
    createScreenViewedEvent({
      current_screen: currentScreen,
    })
  )
}

export const landingPageViewed = () => {
  track(
    createScreenViewedEvent({
      current_screen: "PreQual LandingPage",
    })
  )
}

export const preQualLandingPageIntentClick = ({
  intent,
  id,
  title,
}: {
  intent: string
  id: string
  title: string
}) => {
  track(
    createComponentClickedEvent({
      object_name: intent,
      component_type: "button",
      current_screen: "PreQual LandingPage",
      component_function: `PreQual Landing Page Button ${intent}`,
      component_text: title,
      action_taken: intent,
    })
  )
}

export const preQualQuestionAnswered = ({
  currentScreen,
  question,
  value,
}: {
  currentScreen: AppScreen
  question: PreQualQuestionConfig
  value: string
}) => {
  track(
    createComponentClickedEvent({
      component_type: "question_answer",
      current_screen: currentScreen,
      component_function: `PreQual Question Answer : ${question.questionKey} : ${value}`,
      component_text: value,
      clicked_values: {
        currentScreen,
        question: question.questionKey,
        answer: {
          value,
        },
      },
    })
  )
}
